import React, { useState } from "react";
import "../styles/ReviewManagementSection.css";
import MyPageEmpty from "./MyPageEmpty";
import ReviewHistoryCard from "./ReviewHistoryCard";
import MyReviewCard from "./MyReviewCard";
import { useNavigate } from "react-router-dom"; // ✅ 내가 작성한 리뷰 카드 추가

const ReviewManagementSection = ({ reviewableItemsCount, myReviewCount, reviews, myReviews }) => {
    var navigate = useNavigate();

    // ✅ 페이지네이션 (5개씩 로드)
    const [visibleReviews, setVisibleReviews] = useState(5);
    const [visibleMyReviews, setVisibleMyReviews] = useState(5);

    if (reviewableItemsCount === 0 && myReviewCount === 0) {
        return <><div className="mypage-review-header">
            <h3 className="mypage-review-title">리뷰관리</h3>
            <button className="mypage-review-more-btn" onClick={() => navigate("/mypage/review-list")}>더보기 &gt;</button>
        </div>
        <MyPageEmpty />
            </>
    }

    const loadMoreReviews = () => {
        setVisibleReviews((prev) => prev + 5);
    };

    const loadMoreMyReviews = () => {
        setVisibleMyReviews((prev) => prev + 5);
    };

    let groupedReviews = [];

    // ✅ 주문 날짜별 그룹화 후 배열로 변환
    if (reviewableItemsCount > 0 && myReviewCount > 0) {
        groupedReviews =
            Object.entries(
                reviews.reduce((acc, review) => {
                    const date = review.orderDate;
                    if (!acc[date]) acc[date] = [];
                    acc[date].push(review);
                    return acc;
                }, {})
            );
    }

    // ✅ 리뷰 가능한 상품을 "상품 개수 기준"으로 5개씩 제한
    const flattenedReviews = groupedReviews.flatMap(([date, items]) =>
        items.map((item) => ({ ...item, orderDate: date }))
    ).slice(0, visibleReviews);

    return (
        <div className="mypage-review-section">
            <div className="mypage-review-header">
                <h3 className="mypage-review-title">리뷰관리</h3>
                <button className="mypage-review-more-btn" onClick={() => navigate("/mypage/review-list")}>더보기 &gt;</button>
            </div>

            <div>
                <h4 className="mypage-review-count">리뷰 가능한 상품 {reviewableItemsCount}개</h4>
            </div>

            {/* ✅ 리뷰 가능한 상품 (5개씩 표시) */}
            {reviewableItemsCount === 0 ? <MyPageEmpty /> : (
                flattenedReviews.map((orderItem) => (
                    <ReviewHistoryCard key={orderItem.orderItemId} orderItem={orderItem} />
                ))
            )}

            {/* ✅ 더보기 버튼 (리뷰 가능한 상품) */}
            {reviews.length > visibleReviews && reviewableItemsCount > 0 && (
                <button className="mypage-load-more-btn" onClick={loadMoreReviews}>더보기 +</button>
            )}

            {/* ✅ 내가 작성한 리뷰 목록 */}
            <div className="mypage-my-review-group">
                <h4 className="mypage-review-count">내가 작성한 리뷰 {myReviewCount}개</h4>
                {myReviews.length === 0 ? <MyPageEmpty /> : (
                    myReviews.slice(0, visibleMyReviews).map((orderItem) => (
                        <MyReviewCard key={orderItem.orderItemId} orderItem={orderItem} />
                    ))
                )}
            </div>

            {/* ✅ 더보기 버튼 (내가 작성한 리뷰) */}
            {myReviews.length > visibleMyReviews && myReviewCount > 0 &&(
                <button className="mypage-load-more-btn" onClick={loadMoreMyReviews}>더보기 +</button>
            )}
        </div>
    );
};

export default ReviewManagementSection;
